import React, { useState, useRef } from 'react'
import { Breadcrumbs, CreateButton, DynamicEntityIndex, FlashMessage, GlobalLoader, InputField, Modal } from '@reactiveonline/reactive_admin_shared-packages'
import { dynamicTableItemRenderer, emailValidation } from '@reactiveonline/reactive_admin_shared-packages/utils'
import GlobalImports from '../shared/GlobalImports'

export default function Index({
  appProps, breadcrumbs, canCreate, canDelete, canEdit, deletePath, entityPath, exportOrganizationsPath, icon,
  initialTotalPages, listColumns, organizations, selectedColumns, totalCount
}) {
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [newOrganizationName, setNewOrganizationName] = useState('')
  const [newOrganizationAdministratorEmail, setNewOrganizationAdministratorEmail] = useState('')
  const [newOrganizationInternalName, setNewOrganizationInternalName] = useState('')
  const [newOrganizationUid, setNewOrganizationUid] = useState('')
  const [loading, setLoading] = useState(false)
  const [renderKey, setRenderKey] = useState(0)

  const flashMessageRef = useRef(null)

  const actions = []

  if (canEdit) {
    actions.unshift({ url: item => `${ entityPath }/${ item.apiUid }/edit`, icon: 'fa-pencil' })
  }

  const closeCreateModal = () => {
    setNewOrganizationName('')
    setNewOrganizationAdministratorEmail('')
    setNewOrganizationInternalName('')
    setNewOrganizationUid('')
    setShowCreateModal(false)
  }

  const verifyFields = () => {
    if ([newOrganizationUid, newOrganizationInternalName, newOrganizationName].includes('') || !emailValidation(newOrganizationAdministratorEmail)) {
      return true
    }

    return false
  }

  const createOrganization = () => {
    const fd = new FormData()
    fd.append('name', newOrganizationName)
    fd.append('admin_email', newOrganizationAdministratorEmail)
    fd.append('uid', newOrganizationUid)
    fd.append('internal_name', newOrganizationInternalName)

    setLoading(true)
    closeCreateModal()

    Rails.ajax({
      type: 'POST',
      url: entityPath,
      dataType: 'json',
      data: fd,
      success: res => {
        flashMessageRef.current.show(res.message, 'success')
        setRenderKey(Math.random())
      },
      error: res => {
        flashMessageRef.current.show(res.message, 'error')
      },
      complete: _ => setLoading(false)
    })
  }

  const itemRenderer = (item, columns) => {
    return (
      <>
        { columns.map(column => {
          if (column.label === 'name') {
            return (
              <div key={ column.label } className='item flex-1'>
                <a href={ `${ entityPath }/${ item.apiUid }/edit` }>
                  { item[column.label] }
                </a>
              </div>
            )
          } else if(['createdAt', 'archivedAt'].includes(column.label)) {
            return (
              <div key={ column.label } className='item flex-1'>
                { item[column.label] || '-' }
              </div>
            )
          } else {
            return dynamicTableItemRenderer(item, column)
          }
        })}
      </>
    )
  }

  return (
    <>
      <div className='page-wrapper-header'>
        <div>
          <div className='page-header'>
            <i className={ `fa-light ${ icon }` }/>
            <h1 className='page-header-title'>
              { Partners.translations.organization.plural }
              <span className='m-l-10'>({ totalCount })</span>
            </h1>
          </div>

          <Breadcrumbs
            breadcrumbs={ breadcrumbs }
            wrapperHeader={ false }
          />
        </div>

        { canCreate &&
          <CreateButton
            onClickCreate={ () => setShowCreateModal(true) }
            createTitle={ ReactiveCore.translations.create }
          />
        }
      </div>

      <DynamicEntityIndex
        key={ renderKey }
        initialItems={ organizations }
        initialTotalPages={ initialTotalPages }
        selectAll={ true }
        disableDelete={ !canDelete }
        entity={ 'organizations' }
        tabs={ [] }
        tableHeadings={ selectedColumns }
        disableCustomization={ true }
        itemRenderer={ itemRenderer }
        deletePath={ deletePath }
        itemsPath={ entityPath }
        icon={ icon }
        noResourcesTitle={ Partners.translations.organization.no_organizations }
        listColumns={ listColumns }
        actions={ actions }
        columnTranslations={ Partners.translations.columns }
        fetchOnStart={ renderKey !== 0 }
        isExportable
        exportPath={ exportOrganizationsPath }
      />

      { showCreateModal &&
        <Modal
          visible={ showCreateModal }
          closeModal={ closeCreateModal }
          mode='large'
          action={ createOrganization }
          actionText={ ReactiveCore.translations.create }
          disableAction={ verifyFields() }
        >
          <div
            className='flex-box flex-column flex-1'
          >
            <div className='flex-box' style={{ position: 'relative' }}>
              <div className='bold' style={{ fontSize: 32 }}>
                { Partners.translations.organization.create_organization }
              </div>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.organization.attributes.name }
              >
                <input
                  type='text'
                  value={ newOrganizationName }
                  onChange={ e => setNewOrganizationName(e.target.value) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.organization.organization_administrator_email }
              >
                <input
                  type='text'
                  value={ newOrganizationAdministratorEmail }
                  onChange={ e => setNewOrganizationAdministratorEmail(e.target.value) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.organization.attributes.internal_name }
              >
                <input
                  type='text'
                  value={ newOrganizationInternalName }
                  onChange={ e => setNewOrganizationInternalName(e.target.value) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.organization.attributes.uid }
              >
                <input
                  type='text'
                  value={ newOrganizationUid }
                  onChange={ e => setNewOrganizationUid(e.target.value) }
                />
              </InputField>
            </div>
          </div>
        </Modal>
      }

      { loading && <GlobalLoader fullPage/> }

      <FlashMessage ref={ flashMessageRef } />
      <GlobalImports appProps={ appProps } />
    </>
  )
}